import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {Partner} from "../../models/partner.model";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {PartnerService} from "../../providers/partner.service";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {mobilePhoneNumberValidator, noWhitespaceValidator} from "../../utils/form-validators";
import {ReferralsService} from "../../providers/referrals.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-edit-ambassador',
  templateUrl: './edit-ambassador.component.html',
  styleUrls: ['./edit-ambassador.component.scss'],
})
export class EditAmbassadorComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() partner: Partner;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<Partner>();
  @Output() objectAddedEmitter = new EventEmitter<Partner>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  pc: Partner;
  ambassadorCode: string;
  businessType: number;
  isActive: boolean;
  private ambassadorUpdateSub: Subscription;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private partnerService: PartnerService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private referralsService: ReferralsService,
    private translateService: TranslateService) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.pc = JSON.parse(JSON.stringify(this.partner));
    this.createEditForm();

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });
    this.ambassadorCode = this.partner.ambassadorCode;

    super.ngOnInit();
  }

  createEditForm() {
    this.componentTitle = 'Zmień ambasadora';
    this.actionBtnLabel = 'Zmień ambasadora';
    this.actionQuestion = 'Na pewno chcesz zmienić ambasadora?';
    this.actionSuccess = 'Ambasador został zmieniony';
    this.actionError = 'Wystąpił błąd podczas zmiany ambasadora';
    this.businessType = this.partner.businessType;
    this.isActive = this.partner.active;
    this.formGroup = this.formBuilder.group({
      name: [this.partner.name, [Validators.required, noWhitespaceValidator]],
      email: [this.partner.email, [Validators.email, Validators.required, noWhitespaceValidator]],
      phone: [this.partner.phone, [Validators.required, mobilePhoneNumberValidator, noWhitespaceValidator]],
      taxId: [this.partner.taxId, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]],
      regon: [this.partner.regon, [Validators.required, noWhitespaceValidator, Validators.minLength(9), Validators.maxLength(9)]],
      streetWithNumber: [this.partner.streetWithNumber, [Validators.required, noWhitespaceValidator]],
      city: [this.partner.city, [Validators.required, noWhitespaceValidator]],
      postalCode: [this.partner.postalCode, [Validators.required, noWhitespaceValidator]],
      ambassadorCode: [this.partner.ambassadorCode, Validators.required],
      leadDiscount: [this.partner.leadDiscount, Validators.required],
      ambassadorFee: [this.partner.ambassadorFee, Validators.required],
      leadDiscountMonths: [this.partner.leadDiscountMonths, Validators.required],
      ambassadorDiscountMonths: [this.partner.ambassadorDiscountMonths, Validators.required]
    });

    if (this.isKrsNeeded()) {
      this.formGroup.addControl('krs', new FormControl(this.partner.krs, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
    }
  }

  onAction() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let ambassadorObj: Partner = this.commonUtils.formGroupValuesToObject<Partner>(new Partner(), this.formGroup);

      console.log(ambassadorObj);
      ambassadorObj.type = 'PARTNER';

      ambassadorObj.active = this.isActive;
      ambassadorObj.ambassadorCode = this.ambassadorCode;
      ambassadorObj.id = this.partner.id;
      ambassadorObj.uuid = this.partner.uuid;
      ambassadorObj.businessType = this.businessType;

      ambassadorObj.appPartnerPageTitle = 'AMBASSADOR';
      ambassadorObj.appPartnerPageContent = 'AMBASSADOR';
      ambassadorObj.termsOfServicePageContent = 'AMBASSADOR';

      this.appStateService.updateIsBusySubject(true);
      this.ambassadorUpdateSub = this.referralsService.updateAmbassador(ambassadorObj).subscribe(e => {
        this.appStateService.updateIsBusySubject(false);
        if (e) {
          this.objectEditedEmitter.emit(e);
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas edycji ambasadora');
        }
      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas edycji ambasadora');
        this.appStateService.updateIsBusySubject(false);
      });
    }, () => {
    });
  }

  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }

    if (this.ambassadorUpdateSub) {
      this.ambassadorUpdateSub.unsubscribe();
    }
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  isKrsNeeded() {
    return this.businessType > 3;
  }

  selectBusinessType($event) {
    if (this.isKrsNeeded()) {
      this.formGroup.addControl('krs', new FormControl(this.partner.krs, [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
    } else {
      this.formGroup.removeControl('krs');
    }
  }
}

